"use client"

import type { FunctionComponent, PropsWithChildren } from "react"

import { clsx } from "clsx"
import { usePathname } from "next/navigation"

import { isLinkActive } from "@/modules/headerFooterFO/Header/helpers/isLinkActive"
import { getStudentActiveHrefs } from "@/modules/headerFooterFO/utils/getActiveHrefs"
import { useLocale } from "@/modules/locales/useLocale"

import styles from "@/modules/headerFooterFO/Header/Header.module.css"
import dropdownMenuStyles from "@/modules/headerFooterFO/Header/styles/DropdownMenu.module.css"

type AppHeaderProps = {
  isStudent: boolean
  uuid: string | null
}

export const AppDropdown: FunctionComponent<PropsWithChildren<AppHeaderProps>> = ({ children, isStudent, uuid }) => {
  const pathname = usePathname()
  const locale = useLocale()

  const isUserLinkActivated =
    getStudentActiveHrefs(locale).some(activeLink => isLinkActive(pathname, activeLink, true)) ||
    (isStudent && isLinkActive(pathname, `/${locale}/profiles/${uuid}`))

  return (
    <div className={clsx(dropdownMenuStyles["hdr-DropdownMenu"], styles.account)}>
      <div
        className={clsx(
          dropdownMenuStyles["hdr-DropdownMenu-item"],
          dropdownMenuStyles["hdr-DropdownMenu-item--user"],
          {
            [dropdownMenuStyles["hdr-DropdownMenu-item--userActive"]]: isUserLinkActivated,
          }
        )}
        // eslint-disable-next-line jsx-a11y/no-noninteractive-tabindex
        tabIndex={0} // Used for Safari https://jobteaser.atlassian.net/browse/CRP-590
      >
        {children}
      </div>
    </div>
  )
}
